<template>
  <div>
    <A4PrintPaper :paper="paperData" :questions-per-page="30"/>
  </div>
</template>

<script>
import A4PrintPaper from '@/components/a4PrintPaper/a4PrintPaper.vue';
import {authRequest} from "@/utils/request";

export default {
  components: {
    A4PrintPaper
  },
  data() {
    return {
      paperData: {
        title: '',
        topics: []
      },
      id: null,
      paper: {}
    };
  },
  mounted() {
    this.id = this.$route.params.id
    this.getPaper()
  },
  methods: {
    async getPaper() {
      try {
        let response = await authRequest('paper/' + this.id, {
          method: 'GET'
        })
        this.paper = response.data.data
        if (this.paper.topics) {
          let topics = this.paper.topics
          topics.forEach((item, index) => {
            item.userAnswer = ''
            if (item.types.type === 2 || item.types.type === 4) {
              item.userAnswer = []
            }
            if (item.types.type === 5 && item.parts.length > 0) {
              item.parts.forEach((i, n) => {
                i.userAnswer = ''
                if (i.type === 2 || i.type === 4) {
                  i.userAnswer = []
                }
              })
            }
          })
          topics.sort((a, b) => {
            if (a.types.order === b.types.order) {
              if (!a.outline || !a.outline.order) {
                a.outline = {
                  order: 999999
                }
              }
              if (!b.outline || !b.outline.order) {
                b.outline = {
                  order: 999999
                }
              }
              return a.outline.order - b.outline.order
            }
            return a.types.order - b.types.order
          })

          this.paperData.title = this.paper.title
          this.paperData.topics = topics
        }
      } catch (e) {

      }
    }
  }
};
</script>
